import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/BitcoinCalculator.vue')
    },
    {
      path: '/donation',
      name: 'Donation',
      component: () => import('../views/DonationPage.vue')
    }
  ]
})

export default router
